import { useMemo } from "react";
import { contentKeys } from "./keys";
const primKey = (q) => `${q.t}:${q.layer || ""}:${JSON.stringify(q.pts || q.a || q.c || q.p)}:${q.b || q.s || q.r || ""}`;
const FILL = { PROFILE: "#a1a1aa" };
const STROKE = { LEADER: "#f59e0b", DIM: "#38bdf8", HIDDEN: "#4ade80", SLEEVE: "#4ade80", CENTER: "#ef4444", SLAB: "#ef4444" };

const Dim = ({ q, k }) => {
  const [ax, ay] = q.a, [bx, by] = q.b;
  const ang = Math.atan2(by - ay, bx - ax);
  const nx = -Math.sin(ang) * q.off, ny = Math.cos(ang) * q.off;
  const a2 = [ax + nx, ay + ny], b2 = [bx + nx, by + ny];
  return (
    <g stroke="#38bdf8" strokeWidth={k * 0.6}>
      <line x1={ax} y1={-ay} x2={a2[0]} y2={-a2[1]} />
      <line x1={bx} y1={-by} x2={b2[0]} y2={-b2[1]} />
      <line x1={a2[0]} y1={-a2[1]} x2={b2[0]} y2={-b2[1]} strokeWidth={k} />
      <text x={(a2[0] + b2[0]) / 2} y={-(a2[1] + b2[1]) / 2 - k * 2} fontSize={k * 9} fill="#38bdf8" stroke="none" textAnchor="middle" fontFamily="JetBrains Mono">{q.s}</text>
    </g>
  );
};

export default function DetailSVG({ detail, height = 420 }) {
  const [x0, y0, x1, y1] = detail.bounds;
  const pad = Math.max(x1 - x0, y1 - y0) * 0.06;
  const k = Math.max(x1 - x0, y1 - y0) / 600;
  const items = useMemo(() => contentKeys(detail.prims, primKey).map((key, n) => [key, detail.prims[n]]), [detail.prims]);
  return (
    <svg viewBox={`${x0 - pad} ${-y1 - pad} ${x1 - x0 + 2 * pad} ${y1 - y0 + 2 * pad}`} style={{ height }} className="w-full" data-testid={`detail-svg-${detail.key}`}>
      {items.map(([i, q]) => {
        if (q.t === "poly") {
          const pts = q.pts.map(([x, y]) => `${x},${-y}`).join(" ");
          const fill = q.fill === "#ffffff" ? "#0c0c0f" : q.fill || "none";
          const dash = q.layer === "HIDDEN" || q.layer === "SLEEVE" ? `${k * 6} ${k * 4}` : undefined;
          return q.closed
            ? <polygon key={i} points={pts} fill={q.layer === "PROFILE" ? FILL.PROFILE : fill} fillOpacity={q.layer === "GLASS" ? 0.55 : 1} stroke={STROKE[q.layer] || "#e4e4e7"} strokeWidth={k * 0.7} strokeDasharray={dash} />
            : <polyline key={i} points={pts} fill="none" stroke="#e4e4e7" strokeWidth={k} />;
        }
        if (q.t === "line") return <line key={i} x1={q.a[0]} y1={-q.a[1]} x2={q.b[0]} y2={-q.b[1]} stroke={STROKE[q.layer] || "#a1a1aa"} strokeWidth={k * 0.8} strokeDasharray={q.layer === "CENTER" || q.layer === "SLAB" ? `${k * 8} ${k * 4}` : undefined} />;
        if (q.t === "circle") return <circle key={i} cx={q.c[0]} cy={-q.c[1]} r={q.r} fill={q.fill || "none"} stroke="#e4e4e7" strokeWidth={k * 0.6} />;
        if (q.t === "text") return <text key={i} x={q.p[0]} y={-q.p[1]} fontSize={q.h * 1.15} fill={q.layer === "NOTE" ? "#fbbf24" : "#e4e4e7"} fontFamily="JetBrains Mono">{q.s}</text>;
        if (q.t === "dim") return <Dim key={i} q={q} k={k} />;
        return null;
      })}
    </svg>
  );
}
